import React, { RefObject } from 'react';
import { Popover, PopoverProps } from '@milanote/roma';

import { stopPropagationOnly } from '../../../utils/domUtil';

type ChipSelectionPopoverProps = {
    triggerRef: RefObject<HTMLElement>;
    isOpen?: boolean;
    onOpenChange: (isOpen: boolean) => void;
    children: React.ReactNode | ((close: () => void) => React.ReactNode);
    popoverClassName?: string;
    placement?: PopoverProps['placement'];
    offset?: PopoverProps['offset'];
    crossOffset?: PopoverProps['crossOffset'];
};

const renderChildren = (children: ChipSelectionPopoverProps['children'], close: () => void) =>
    typeof children === 'function' ? children(close) : children;

/**
 * Renders a popover whose open state is driven by generic chip selection.
 */
const ChipSelectionPopover: React.FC<ChipSelectionPopoverProps> = ({
    triggerRef,
    isOpen,
    onOpenChange,
    popoverClassName,
    children,
    placement,
    offset,
    crossOffset,
}) => {
    const close = () => onOpenChange(false);

    return (
        <Popover
            arrow
            triggerRef={triggerRef}
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            popoverClassName={popoverClassName}
            onMouseDown={stopPropagationOnly}
            onClick={stopPropagationOnly}
            placement={placement}
            offset={offset}
            crossOffset={crossOffset}
        >
            {renderChildren(children, close)}
        </Popover>
    );
};

export default ChipSelectionPopover;
